import React, { memo } from 'react';
import { EsitiUnderThreeWithInfoAggEstesaItem } from 'components/scommesseTipo/scommesseTipoEsitiUnderThreeWithInfoAggEstesa';
import { ScommesseListing } from 'components/scommesseTipo/wrappers/scommesseListing';
import { ScommesseTipoProps } from 'components/scommesseTipo/types';
import { useInfoAggiuntivaIndex, useIsAvvenimento } from 'features/sport/hooks';
import useWindowSize from 'hooks/useWindowSize';

export const Scommessa = memo(function Scommessa({ scommessaKey, gtagAction }: ScommesseTipoProps) {
  const { nextInfoAgg } = useInfoAggiuntivaIndex(scommessaKey);
  const { isMobile } = useWindowSize();
  const isAvvenimento = useIsAvvenimento();

  return (
    <ScommesseListing>
      {nextInfoAgg?.map((infoAggiuntivaKey, index) => (
        <EsitiUnderThreeWithInfoAggEstesaItem
          showHeader={isMobile || (index === 0 && !isMobile && !isAvvenimento) || isAvvenimento}
          key={infoAggiuntivaKey}
          scommessaKey={scommessaKey}
          infoAggiuntivaKey={infoAggiuntivaKey}
          gtagAction={gtagAction}
        />
      ))}
    </ScommesseListing>
  );
});
